var map = {
	"./Consumables.png": 292,
	"./Equipments.png": 293,
	"./Stationary.png": 294,
	"./Surgicals.png": 295,
	"./devices.png": 296,
	"./implants.png": 297,
	"./pharma.png": 298,
	"./vaccines.png": 299
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 291;